var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('div',{staticClass:"d-flex flex-row justify-space-between pb-3"},[_c('p',{staticClass:"charcoal--text pb-0 mb-0",staticStyle:{"font-size":"1.125rem"}},[_vm._v(" Selecione o contrato desejado: ")]),_c('v-btn',{staticClass:"muted-immutable--text rounded-pill",attrs:{"color":"primary"},on:{"click":function($event){_vm.allContractsChecked
					? _vm.uncheckAllContracts()
					: _vm.checkAllContracts()}}},[_vm._v(" "+_vm._s(_vm.allContractsChecked ? 'Desmarcar todos' : 'Selecionar todos')+" ")])],1),_c('v-simple-table',{staticClass:"overflow-auto default-table-height",staticStyle:{"max-height":"215px","border":"1px solid color-mix(in srgb, var(--v-border-base), transparent 20%)"}},[_c('thead',{staticClass:"muted"},[_c('tr',_vm._l((_vm.headers),function(header){return _c('th',{key:header.text,staticClass:"text-left primary--text text-subtitle-1 font-weight-medium",style:(header.style)},[_vm._v(" "+_vm._s(header.text)+" ")])}),0)]),_c('tbody',_vm._l((_vm.getInvoiceValidations),function(item,key){return _c('tr',{key:key,class:{
						'text-subtitle-1 foreground--text font-weight-regular': true,
						'invoice-contract-selected': _vm.contractInSelection(item)
					},on:{"click":function($event){return _vm.selectInvoice(item)}}},[_c('td',{staticStyle:{"width":"320px"}},[_vm._v(" "+_vm._s(item.validationId)+" ")]),_c('td',{staticStyle:{"width":"320px"}},[_vm._v(" "+_vm._s(item.financialGroup.name)+" ")]),_c('td',{staticStyle:{"min-width":"500px"}},[_vm._v(" "+_vm._s(item.name)+" ")]),_c('td',{staticStyle:{"width":"300px"}},[_vm._v(" "+_vm._s(_vm.getDateOfIssueInvoice(item.validationId))+" ")]),_c('td',{staticStyle:{"width":"300px"}},[_vm._v(" "+_vm._s(_vm.getCuttingPeriod(item.validationId))+" ")]),_c('td',{staticStyle:{"min-height":"100%","min-width":"60px"}},[_c('div',{staticClass:"d-flex justify-end fill-height"},[(_vm.contractInSelection(item))?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" fas fa-check ")]):_vm._e()],1)])])}),0)])],1),_c('v-col',{staticClass:"d-flex justify-end pb-0"},[_c('v-btn',{staticClass:"rounded-pill",attrs:{"height":"39px","width":"100%","max-width":"350","color":"primary"},on:{"click":_vm.showDetails}},[_vm._v(" Detalhes ")])],1),(_vm.selectedContracts.length > 0)?[_c('v-col',{staticClass:"py-0 mt-5",attrs:{"cols":"12"}},[_c('span',{staticClass:"primary--text font-weight-bold text-h6"},[_vm._v(" Conferência de fatura ")])]),_vm._l(([
				{
					title: 'Total de registros',
					cards: [
						{
							label: 'Validados com sucesso',
							value: _vm.allSuccessRegistryDetailIds,
							icon: 'check',
							type: 'register',
							status: 'SUCCESS',
							isInvoice: true,
							key: 'successRegistryDetailIds'
						},
						{
							label: 'Validados com erro',
							value: _vm.allErrorRegistryDetailIds,
							icon: 'mdi mdi-exclamation',
							type: 'register',
							status: 'ERROR',
							isInvoice: true,
							key: 'errorRegistryDetailIds'
						},
						{
							label: 'Com erro - conferido',
							value: _vm.allErrorRegistryDetailIdsChecked,
							icon: 'mdi mdi-exclamation',
							secondaryIcon: 'check',
							type: 'register',
							status: 'ERROR',
							isInvoice: true,
							key: 'errorRegistryDetailIdsChecked'
						},
					]
				},
				{
					title: 'Total de lançamentos de valores',
					cards: [
						{
							label: 'Validados com sucesso',
							value: _vm.allSuccessValueDetailIds,
							icon: 'check',
							type: 'value',
							status: 'SUCCESS',
							isInvoice: false,
							key: 'successValueDetailIds'
						},
						{
							label: 'Validados com erro',
							value: _vm.allErrorValueDetailIds,
							icon: 'mdi mdi-exclamation',
							tpye: 'value',
							status: 'ERROR',
							isInvoice: false,
							key: 'errorValueDetailIds'
						},
						{
							label: 'Com erro - conferido',
							value: _vm.allErrorValueDetailIdsChecked,
							icon: 'mdi mdi-exclamation',
							secondaryIcon: 'check',
							type: 'value',
							status: 'ERROR',
							isInvoice: true,
							key: 'errorValueDetailIdsChecked'
						},
					]
				},
				{
					title: 'Total de registros não localizados',
					cards: [
						{
							multi: [
								{
									label: 'Fatura',
									value: _vm.allNotFoundInvoiceDetailIds,
									icon: 'search',
									type: 'register',
									status: 'NOT_FOUND',
									isInvoice: true,
									key: 'notFoundInvoiceDetailIds',
								},
								{
									label: 'Prévia',
									value: _vm.allNotFoundPreviewDetailIds,
									icon: 'search',
									type: 'value',
									status: 'NOT_FOUND',
									isInvoice: false,
									key: 'notFoundPreviewDetailIds',
								},
							]
						},
						{
							label: 'Fatura - conferido',
							value: _vm.allNotFoundInvoiceDetailIdsChecked,
							icon: 'mdi mdi-exclamation',
							secondaryIcon: 'search',
							type: 'value',
							status: 'NOT_FOUND',
							isInvoice: false,
							key: 'notFoundInvoiceDetailIdsChecked',
						},
						{
							label: 'Prévia - conferido',
							value: _vm.allNotFoundPreviewDetailIdsChecked,
							icon: 'mdi mdi-exclamation',
							secondaryIcon: 'search',
							type: 'register',
							status: 'NOT_FOUND',
							isInvoice: true,
							key: 'notFoundPreviewDetailIdsChecked'
						},
					]
				}
			]),function(item,registerKey){return _c('v-col',{key:'register' + registerKey,staticClass:"pt-0"},[_c('v-col',{staticClass:"d-flex flex-column pa-0"},[_c('span',{staticClass:"primary--text font-weight-bold text-subtitle-1"},[_vm._v(" "+_vm._s(item.title)+" ")]),_vm._l((item.cards),function(card,indexCard){return [(card.multi)?_c('div',[_c('v-sheet',[_c('v-row',{attrs:{"no-gutters":""}},[_vm._l((card.multi),function(innerCard,indexInnerCard){return [_c('v-col',[_c('ConferenceCard',{class:indexInnerCard <= 1 ? 'mb-6' : '',staticStyle:{"cursor":"pointer"},attrs:{"label":innerCard.label,"value":innerCard.value,"indexInnerCard":indexInnerCard,"isMulti":true},on:{"selectCard":function($event){return _vm.selectCard(registerKey, 'register', innerCard)}}})],1)]})],2)],1)],1):_c('div',[_c('ConferenceCard',{class:indexCard <= 1 ? 'mb-6' : '',staticStyle:{"cursor":"pointer"},attrs:{"label":card.label,"value":card.value,"icon":card.icon,"secondaryIcon":card.secondaryIcon},on:{"selectCard":function($event){return _vm.selectCard(registerKey, 'register', card)}}})],1)]})],2)],1)})]:_vm._e(),_c('SnackbarCustomize',{ref:"SnackbarCustomize"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }